import React, { useState } from 'react';
import { Product, SizeRecommendForm } from '../types';
import { sizeRecommend }              from '../utils/api';
import { OCCASIONS }                  from '../utils/constants';
import './SizeRecommender.css';

interface SizeRecommenderProps {
  product?: Product;
}

const EMPTY_FORM: SizeRecommendForm = {
  height: '', weight: '', bust: '', waist: '', hips: '',
  occasion: 'Casual', preference: 'Traditional',
};

const SizeRecommender: React.FC<SizeRecommenderProps> = ({ product }) => {
  const [form,    setForm]    = useState<SizeRecommendForm>(EMPTY_FORM);
  const [result,  setResult]  = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const set = (k: keyof SizeRecommendForm, v: string): void =>
    setForm(f => ({ ...f, [k]: v }));

  const recommend = async (): Promise<void> => {
    setLoading(true);
    try {
      const data = await sizeRecommend(form, product);
      setResult(data.recommendation);
    } catch {
      setResult('Could not get recommendation. Please contact us on WhatsApp for size guidance.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="size-recommender">
      <div className="sr-header">
        <h4>🤖 AI Size & Style Guide</h4>
        <p>Enter your measurements for a personalised recommendation</p>
      </div>

      <div className="sr-grid">
        {([
          ['height', 'Height (cm)',   'e.g. 162'],
          ['weight', 'Weight (kg)',   'e.g. 58' ],
          ['bust',   'Bust (inches)', 'e.g. 36' ],
          ['waist',  'Waist (inches)','e.g. 30' ],
          ['hips',   'Hips (inches)', 'e.g. 38' ],
        ] as [keyof SizeRecommendForm, string, string][]).map(([key, label, placeholder]) => (
          <div key={key} className="field">
            <label htmlFor={`sr-${key}`}>{label}</label>
            <input id={`sr-${key}`} type="number" placeholder={placeholder}
                   value={form[key]} onChange={e => set(key, e.target.value)} />
          </div>
        ))}
        <div className="field">
          <label htmlFor="sr-occasion">Occasion</label>
          <select id="sr-occasion" value={form.occasion} onChange={e => set('occasion', e.target.value)}>
            {OCCASIONS.map(o => <option key={o}>{o}</option>)}
          </select>
        </div>
      </div>

      <button className="btn-primary btn-block" onClick={recommend} disabled={loading}>
        {loading ? 'Analysing…' : '✨ Get AI Recommendation'}
      </button>

      {result && (
        <div className="sr-result">
          <div className="sr-result-icon">👗</div>
          <div style={{ whiteSpace: 'pre-wrap', fontSize: '14px', lineHeight: '1.7' }}>{result}</div>
        </div>
      )}
    </div>
  );
};

export default SizeRecommender;
